import axios from "axios";
import { Formik } from "formik";
import * as Yup from "yup";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { Redirect, useHistory, useLocation, useParams } from "react-router-dom";
import { Col, Input, Row, Button, Form, Label } from "reactstrap";
import { UserConsumer } from "../../../../UserContext";
import { spOffsiteWorkHours_API } from "../spOffsiteWorkHours_API";
import { AlertPopups } from "../../../../components/AlertPopups";
import FormStatus from "../../../../components/FormStatus";
import { Routes } from "../../../../configurations/config";

function ManageOffsiteWorkRequest() {
	let token = null;
	const { id } = useParams();
	const history = useHistory();
	const { state } = useLocation();
	const [requestStatus, setRequestState] = useState(
		state ? state.requestStatus : null
	);
	const initialValues = {
		supervisorComments: "",
	};
	const [showCompensationForm, setShowCompensationForm] = useState(false);
	const [isWeekendOrPublicHoliday, setIsWeekendOrPublicHoliday] =
		useState(null);
	const [editCompensation, setEditCompensation] = useState(true);
	const [disableSuggestedCompensation, setDisableSuggestedCompensation] =
		useState(false);
	const [isCompensated, setIsCompensated] = useState(null);
	const [compensationFormFields, setCompensationFormFields] = useState(null);
	const [apiTokenHeader, setApiTokenHeader] = useState(null);
	const [suggestCompensation, setSuggestCompensation] = useState(null);
	const [offsiteRequestDetail, setOffsiteRequestDetail] = useState([]);
	const [formFields, setFormFields] = useState(initialValues);
	const [isCompensationExpired, setIsCompensationExpired] = useState(false);
	const validate = Yup.object().shape({
		supervisorComments: Yup.string()
			.required("Comments is Required")
			.max(500, "Max 500 characters allowed")
			.nullable(),
	});
	const validateCompensation = Yup.object().shape({
		compensation: Yup.string()
			.nullable()
			.min(1, "Password must be at least 8 characters"),
	});
	useEffect(() => {
		//when to show Compensation form
		if (requestStatus === "Approved")
			if (isWeekendOrPublicHoliday) setShowCompensationForm(true);

		const header = { Authorization: `Bearer ${token}` };
		//get WorkType List
		axios
			.get(
				`${spOffsiteWorkHours_API.GetDefaultEmployeeOffsiteRequestByID}/${id}`,
				{
					headers: header,
				}
			)
			.then(({ status, data }) => {
				if (status === 200) {
					let isWeekendOrPublicHoliday =
						data.isWeekendOrPublicHoliday;
					setOffsiteRequestDetail(data);
					setIsWeekendOrPublicHoliday(isWeekendOrPublicHoliday);
					setRequestState(data.supStatus);
					setSuggestCompensation(data.suggestedCompensation);

					// ADDED: Read expiry flag from API response
					var expired = data.isCompensationExpired || false;
					setIsCompensationExpired(expired);

					if (data.isCompensated === 0) {
						setIsCompensated(false);
						// CHANGED: Disable editing when expired
						var canEdit = !expired;
						setEditCompensation(canEdit);
						if (isWeekendOrPublicHoliday) {
							setShowCompensationForm(true);
							setEditCompensation(canEdit);
						}
					}
					if (data.isCompensated === 1) {
						setIsCompensated(true);
						setEditCompensation(false);
						if (isWeekendOrPublicHoliday) {
							setShowCompensationForm(true);
							setEditCompensation(false);
						}
					}
				}
			});

		setApiTokenHeader(header);
	}, []);

	useEffect(() => {
		if (isCompensated) {
			axios
				.get(`${spOffsiteWorkHours_API.GetCompensationById}/${id}`, {
					headers: { Authorization: `Bearer ${token}` },
				})
				.then(({ status, data }) => {
					if (status === 200) {
						setCompensationFormFields(data);
					}
				});
		} else {
			setCompensationFormFields({
				ClientCompensation: false,
				isInternalCompensation: false,
				compensation: suggestCompensation,
			});
		}
	}, [isCompensated]);
	const handleApprove = () => {
		reviewOffsiteWorkRequest(3);
	};
	const handleSubmit = () => {
		reviewOffsiteWorkRequest(2);
	};
	const reviewOffsiteWorkRequest = (approvalStatus) => {
		const formBody = {
			supervisorComments: formFields.supervisorComments,
			approvalStatus: approvalStatus,
		};

		axios
			.patch(
				`${spOffsiteWorkHours_API.PatchEmployeeOffsiteHourRequests}/${id}`,
				formBody,
				{
					headers: apiTokenHeader,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					if (approvalStatus === 2) {
						AlertPopups.successAlert.fire({
							text: "Offsite Request Reviewed",
						});
						history.push(Routes.spOffsiteWorkHours);
					} else {
						window.location.reload();
					}
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};
	const approveCompensation = () => {
		if (
			compensationFormFields.compensation === null ||
			compensationFormFields.compensation === ""
		) {
			AlertPopups.ErrorAlert.fire({
				text: "Enter Values",
			});
		}
		if (compensationFormFields.compensation > suggestCompensation) {
			AlertPopups.confirmBox
				.fire({
					text: `${"Are you Sure?"}`,
				})
				.then((result) => {
					if (result.value) {
						APIcallForCompensation();
					}
				});
		} else if (
			compensationFormFields.compensation === suggestCompensation ||
			compensationFormFields.compensation < suggestCompensation
		) {
			APIcallForCompensation();
		}
	};
	const APIcallForCompensation = () => {
		axios
			.post(
				`${spOffsiteWorkHours_API.PostCompensation}/${id}/Compensation`,
				compensationFormFields,
				{
					headers: apiTokenHeader,
				}
			)
			.then(({ status, message }) => {
				if (status === 200) {
					AlertPopups.successAlert.fire({
						text: "Compensation Approved",
					});
					history.push(Routes.spOffsiteWorkHours);
				} else if (status === 400) {
					AlertPopups.ErrorAlert.fire({
						text: message,
					});
				}
			})
			.catch((error) => {
				if (error.response)
					AlertPopups.ErrorAlert.fire({
						text: error.response.data.message,
					});
			});
	};
	const getImageByStatus = (status) => {
		switch (status.toLowerCase()) {
			case "approved":
				return (
					<img
						title="Approved"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/approved.jpg"
					/>
				);
			case "rejected":
				return (
					<img
						title="Rejected"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/rejected.jpg"
					/>
				);
			case "invalid":
				return (
					<img
						title="Invalid"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/invalid.jpg"
					/>
				);
			default:
				return (
					<img
						title="Pending"
						src="https://teo-staging.teo-intl.com/Assets/images/pages/pending.jpg"
					/>
				);
		}
	};
	const onCompensationCheckboxClick = (type) => {
		if (type === "internal") {
			setCompensationFormFields({
				...compensationFormFields,
				isInternalCompensation:
					!compensationFormFields.isInternalCompensation,
				isClientCompensation: false,
				compensation: 0,
			});
			setDisableSuggestedCompensation(false);
		} else if (type === "client") {
			setCompensationFormFields({
				...compensationFormFields,
				isClientCompensation:
					!compensationFormFields.isClientCompensation,
				isInternalCompensation: false,
				compensation: suggestCompensation,
			});
			setDisableSuggestedCompensation(false);
		}
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				return userDetails.designation.toString() === "4" ||
					userDetails.empRole.includes("2") ||
					userDetails.empRole.includes("5") ||
					userDetails.empRole.includes("3") ? (
					<div className="container-fluid pl-2 pr-2 my-2">
						<FormStatus
							id={id}
							title="Offsite Work Requests"
							formStatus={requestStatus}
							className="create-request d-flex align-items-center"
							onClick={() => {
								history.push(Routes.spOffsiteWorkHours);
							}}
							navigateBack={true}
						/>

						<>
							<div className="formInfoContainer my-3">
								<div className="formInfoContainerHeader">
									<Label sm={12}>Offsite Work Details</Label>
								</div>
								<Formik
									enableReinitialize={true}
									initialValues={formFields}
									validationSchema={validate}
									validateOnChange={true}
									onSubmit={() => {
										handleSubmit();
									}}
								>
									{({ errors, handleSubmit }) => (
										<Form>
											{requestStatus === "Pending" ? (
												<>
													<Col>
														<Row className="py-2 px-2">
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Name
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{
																		offsiteRequestDetail.employeeName
																	}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Worked
																		Date
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{moment(
																		offsiteRequestDetail.requestDate
																	).format(
																		"DD/MM/YYYY"
																	) +
																		" (" +
																		moment(
																			offsiteRequestDetail.requestDate
																		).format(
																			"dddd"
																		) +
																		")"}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Start
																		Time
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{moment(
																		offsiteRequestDetail.startTime,
																		"hh"
																	).format(
																		"LT"
																	)}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Work
																		Duration
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{" "}
																	{offsiteRequestDetail.workingHours +
																		" Hr " +
																		offsiteRequestDetail.workingMinutes +
																		" Min"}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Work
																		Type
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{
																		offsiteRequestDetail.workType
																	}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Reason
																		for Work
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{
																		offsiteRequestDetail.employeeComments
																	}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Your
																		Comments
																	</div>
																</div>
															</Col>
															<Col lg={5}>
																<Row className="align-items-center">
																	<Col
																		lg={7}
																		className="pr-lg-1"
																	>
																		<Input
																			type="textarea"
																			name="employeeComments"
																			value={
																				offsiteRequestDetail.supComments
																			}
																			className={`my-1 supDesciptionBox ${
																				errors.supervisorComments
																					? "h-auto invalid"
																					: "h-auto"
																			}`}
																			disabled={
																				showCompensationForm
																			}
																			onChange={(
																				event
																			) => {
																				setFormFields(
																					{
																						supervisorComments:
																							event
																								.target
																								.value,
																					}
																				);
																			}}
																		/>
																	</Col>

																	<Col
																		md={12}
																		lg={5}
																	>
																		<p className="pl-2 formValueContainer">
																			Updated
																			On{" "}
																			{moment(
																				offsiteRequestDetail.employeeLastUpdated
																			).format(
																				"DD/MM/YYYY HH:MM A"
																			)}
																		</p>
																	</Col>
																</Row>
															</Col>
														</Row>
													</Col>
													{showCompensationForm ? null : (
														<div className="btns">
															<Button
																className="delete-btn leftBtn"
																onClick={
																	handleSubmit
																}
															>
																Reject
															</Button>
															<Button
																className="approve-btn"
																onClick={
																	handleApprove
																}
															>
																Approve
															</Button>
														</div>
													)}
												</>
											) : (
												<>
													{" "}
													<Col>
														<Row className="py-2 px-4">
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Employee
																		Name
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<p className="formValueContainer">
																		{
																			offsiteRequestDetail.employeeName
																		}
																	</p>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Requested
																		Date
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{moment(
																		offsiteRequestDetail.requestDate
																	).format(
																		"DD/MM/YYYY"
																	) +
																		" (" +
																		moment(
																			offsiteRequestDetail.requestDate
																		).format(
																			"dddd"
																		) +
																		")"}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Start
																		Time
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{moment(
																		offsiteRequestDetail.startTime,
																		"hh"
																	).format(
																		"LT"
																	)}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Work
																		Duration
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{" "}
																	{offsiteRequestDetail.workingHours +
																		" Hr " +
																		offsiteRequestDetail.workingMinutes +
																		" Min"}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Work
																		Type
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{
																		offsiteRequestDetail.workType
																	}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Reason
																		for Work
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<p className="formValueContainer">
																	{
																		offsiteRequestDetail.employeeComments
																	}
																</p>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Supervisor's
																		Comments
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<Row className="align-items-center">
																	<Col lg={1}>
																		{offsiteRequestDetail.supStatus
																			? getImageByStatus(
																					offsiteRequestDetail.supStatus
																			  )
																			: null}
																	</Col>
																	<Col lg={9}>
																		<Input
																			type="textarea"
																			name="employeeComments"
																			value={
																				offsiteRequestDetail.supComments
																					? offsiteRequestDetail.supComments
																					: ""
																			}
																			disabled={
																				true
																			}
																			className={`ml-1 supDesciptionBox ${
																				errors.supervisorComments
																					? "h-auto invalid"
																					: "h-auto"
																			}`}
																			onChange={(
																				event
																			) =>
																				setFormFields(
																					{
																						supervisorComments:
																							event
																								.target
																								.value,
																					}
																				)
																			}
																		/>
																	</Col>
																</Row>
															</Col>
															<Col md={12} lg={3}>
																<div className="formDetailHeader">
																	<div>
																		Admin's
																		Comments
																	</div>
																</div>
															</Col>
															<Col md={12} lg={3}>
																<Row className="align-items-center">
																	<Col lg={1}>
																		{offsiteRequestDetail.adminStatus
																			? getImageByStatus(
																					offsiteRequestDetail.adminStatus
																			  )
																			: null}
																	</Col>
																	<Col lg={9}>
																		<Input
																			type="textarea"
																			name="employeeComments"
																			disabled={
																				true
																			}
																			className="my-1 ml-1 supDesciptionBox"
																			value={
																				offsiteRequestDetail.adminComments
																					? offsiteRequestDetail.adminComments
																					: ""
																			}
																		/>
																	</Col>
																</Row>
															</Col>
														</Row>
													</Col>
												</>
											)}
										</Form>
									)}
								</Formik>
							</div>

						{showCompensationForm && compensationFormFields ? (
							<div
								className="pt-5 mt-2 formInfoContainer"
								style={{ backgroundColor: "white" }}
							>
								<div className="formInfoContainer">
									<div className="formInfoContainerHeader">
										<Label sm={12}>
											Compensation Approval
										</Label>
									</div>
									{isCompensationExpired && (
										<div className="px-3 py-2">
											<span style={{ color: "red", fontWeight: "bold" }}>
												Compensation approval is no longer available. The 2-month window from the worked/requested date has expired.
											</span>
										</div>
									)}
									<Formik
										enableReinitialize={true}
										initialValues={compensationFormFields}
										validationSchema={validateCompensation}
										validateOnChange={true}
									>
										{({ errors, handleSubmit }) => (
											<Form>
												<Col>
													<Row className="py-2 px-2">
														<Col md={5} lg={3}>
															<div className="formDetailHeader">
																<div>
																	Suggest
																	Compensation{" "}
																	<span className="required">
																		*
																	</span>
																</div>
															</div>
														</Col>
														<Col md={5} lg={2}>
															<Input
																type="number"
																style={{
																	marginTop:
																		"3px",
																}}
																className={`formValueInput ${
																	errors.compensation
																		? "h-auto invalid"
																		: "h-auto"
																}`}
																disabled={
																	!editCompensation ||
																	disableSuggestedCompensation
																}
																onChange={(
																	event
																) => {
																	if (
																		event
																			.target
																			.value !=
																		""
																	)
																		setCompensationFormFields(
																			{
																				...compensationFormFields,
																				compensation:
																					event
																						.target
																						.value,
																			}
																		);
																	else
																		setCompensationFormFields(
																			{
																				...compensationFormFields,
																				compensation:
																					null,
																			}
																		);
																}}
																value={
																	compensationFormFields.compensation
																}
																maxLength="500"
															/>
														</Col>

														<Col
															md={5}
															lg={2}
															className="pl-3 ml-4"
														>
															<div className="formDetailHeader">
																<div>
																	Internal
																	Compensation
																</div>
															</div>
														</Col>
														<Input
															className="mr-5 radioButtonInput"
															type="radio"
															name="compensation"
															checked={
																compensationFormFields.isInternalCompensation
															}
															value={
																compensationFormFields.isInternalCompensation
															}
															disabled={
																!editCompensation
															}
															onChange={() => {
																onCompensationCheckboxClick(
																	"internal"
																);
															}}
														/>

														<Col
															md={5}
															lg={2}
															className="pl-3 mr-2"
														>
															<div className="formDetailHeader ml-4">
																<div>
																	Client
																	Compensation
																</div>
															</div>
														</Col>
														<Input
															className="radioButtonInput"
															type="radio"
															name="compensation"
															checked={
																compensationFormFields.isClientCompensation
															}
															disabled={
																!editCompensation
															}
															onChange={() => {
																onCompensationCheckboxClick(
																	"client"
																);
															}}
														/>
													</Row>
												</Col>
												{editCompensation ? (
													<div className="btns">
														<Button
															className="approveCompensation-btn"
															onClick={() =>
																approveCompensation()
															}
														>
															Add Compensation
														</Button>
													</div>
												) : null}
											</Form>
										)}
									</Formik>
								</div>
							</div>
						) : null}
						</>
					</div>
				) : (
					<Redirect to="/MyDashboard" />
				);
			}}
		</UserConsumer>
	);
}
export default ManageOffsiteWorkRequest;
